var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0002 6C27.0094 5.99968 27.9814 6.38081 28.7213 7.06699C29.4613 7.75317 29.9145 8.69369 29.9902 9.7L30.0002 10V38H32.0002V19C32.0001 18.7659 32.0822 18.5393 32.232 18.3595C32.3818 18.1797 32.59 18.0581 32.8202 18.016L33.0002 18H36.0002C37.0094 17.9997 37.9814 18.3808 38.7213 19.067C39.4613 19.7532 39.9145 20.6937 39.9902 21.7L40.0002 22V38H42.0002C42.51 38.0006 43.0003 38.1958 43.371 38.5457C43.7416 38.8956 43.9647 39.3739 43.9946 39.8828C44.0244 40.3917 43.8589 40.8928 43.5317 41.2837C43.2045 41.6746 42.7404 41.9258 42.2342 41.986L42.0002 42H6.00023C5.49047 41.9994 5.00016 41.8042 4.62949 41.4543C4.25882 41.1044 4.03576 40.6261 4.00588 40.1172C3.97601 39.6083 4.14157 39.1072 4.46876 38.7163C4.79594 38.3254 5.26003 38.0742 5.76623 38.014L6.00023 38H8.00023V10C7.99991 8.99085 8.38104 8.01887 9.06722 7.2789C9.7534 6.53894 10.6939 6.08569 11.7002 6.01L12.0002 6H26.0002ZM22.0002 30H16.0002V34H22.0002V30ZM22.0002 22H16.0002V26H22.0002V22ZM22.0002 14H16.0002V18H22.0002V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.a6274da21b58fb587ac0a489ffd061ff.svg";
export { ForwardRef as ReactComponent };